export const FAVOURITES_COOKIE_NAME = "gethome-favourites";
export const FAVOURITES_LS_NAME = "gethome-favourites";
export const VISITED_COOKIE_NAME = "gethome-visited";
export const VISITED_LS_NAME = "gethome-visited";
export const LAST_SEARCH_LS_KEY = "gethome-lastSearch";
export const IS_COOKIE_MESSAGE_READ_LS_KEY = "gethome-cookieMessageIsRead";
export const UTM_DATA_LS_KEY = "gethome-utmData";
export const UTM_DATA_TIME_LS_KEY = "gethome-utmData-time";
export const INDIVIDUAL_OFFER_FORM_STATE_KEY = "add-individual-offer-form-state";
